import { IPlanPhongHocTrongKyAsyncRequest } from "../../../model/request/category/IPlanPhongHocTrongKyAsyncRequest";
import { IPlanPhongHocTrongKy } from "../../../model/respone/category/IPlanPhongHocTrongKy";
import { IPlanPhongHocTrongKyViewModel } from "../../../model/respone/category/IPlanPhongHocTrongKyViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const ePhongHocTrongKyActionsObj = {
    LOAD_START: {hoc_ky: 0, nam_hoc: ""},
    LOAD_SUCCESS: {} as IPlanPhongHocTrongKyViewModel[],
    LOAD_ERRR: "",

    ASYNC_START: {} as IPlanPhongHocTrongKyAsyncRequest,
    ASYNC_SUCCESS: "",
    ASYNC_ERRR: "",

    CHANGE_SELECTED_IDS_PHONG_HOC_CHUA_CHON: {} as number[],
    CHANGE_SELECTED_IDS_PHONG_HOC_DA_CHON: {} as number[],

    UPDATE_START: {} as IPlanPhongHocTrongKy,
    UPDATE_SUCCESS: {} as IPlanPhongHocTrongKy,
    UPDATE_ERRR: "",
};


export const ePhongHocTrongKyActionIds = generateActionTypeIds(ePhongHocTrongKyActionsObj, "PHONG_HOC_TRONG_KY");
export type IPhongHocTrongKyActionTypes = IGenericActionType<typeof ePhongHocTrongKyActionsObj, "PHONG_HOC_TRONG_KY">;